import { createRequest, RequestConfig } from 'app/common/api';

import { TEmployee } from '../../employees/core/employee';
import { TTerminalProfile } from '../core/profiles';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/add_terminal_profile',
};
type AddTerminalProfileRequestParams = Omit<
  TTerminalProfile,
  'id' | 'employees'
> & {
  employees: Pick<TEmployee, 'id'>[];
};

export const addTerminalProfileRequest = (
  body: AddTerminalProfileRequestParams
) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(body),
  });
